/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThumbsDownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABM0lEQVR4nN2UPUoEQRCFS1GvIGjgDYxFg8ndrR8HeqtWkA2UyTzDpHsCE1PBEygKRuoBxMCfA6hsKBiqI80msmzPrt0jiA8q7Pd1vepqgH+noijmUfSQRN9IrKqpT2R9RtEz5u6ePzcVAMW6E4yrcYWit4i2OBHgbxMDIF+sVwAwUwsgsiVk/YiFoGg7aJ5l2RyxHUR3IFYh21EQ0GbdSTGnIeAuPGC2/VQAsb0EAa2WW0a296QOxB6CAGZdTxkwDSM6DgKI7Tx5BqJ5HeA6Mf+bsixnw0Pe6qwh22McQF8RbRVi5JxbINb7cO46wLyzEWXuhWK9msxP/PZDiojtdGwkrLvQhJB1MAK42My3Vxox9xpdvqm+5Z8IRZ++A6BpkVj/VwHOP1Oxvu8ExS4bB/xpfQGBBNs8YWmBeAAAAABJRU5ErkJggg==)
 */
export const ThumbsDownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9 19a3 3 0 0 0 3 3 1 1 0 0 0 1-1v-2a3 3 0 0 1 .19-1.05l4.26-2.88a7.9 7.9 0 0 0 3.26-8.4c-.43-1.77-1.44-3.42-3.14-4.07a8.3 8.3 0 0 0-2.95-.6H6.59a2.09 2.09 0 0 0-1.93 2.88l.4.97a.2.2 0 0 1-.08.24l-.54.33a1.99 1.99 0 0 0-.8 2.44l.43 1.02c.03.07.02.16-.03.23l-.6.9A1.92 1.92 0 0 0 5.04 14h5.39A8 8 0 0 0 9 18.56V19Z"
        className={colorClass}
      />
    </svg>
  );
};
